import { Component } from "react";
import { graphql } from "gatsby";
import { ActivityBooking, extract } from "@parksandresorts/core";
import BookableShowBooking from "./bookable-show-booking/bookable-show-booking";

export default class ShowBookingBlock extends Component {
  constructor(props) {
    super(props);
    this.title = extract(props, "title");
    this.typeText = extract(props, "typeText");
    this.headline = extract(props, "headline");
    this.introText = extract(props, "introText.introText");
    this.todayText = extract(props, "todayText");
    this.product = extract(props, "product");
    this.duration = extract(props, "duration", null);
    this.location = extract(props, "activityLocation.title", null);
    this.richTextDescripton = extract(props, "description", undefined);
    this.isActivityBooking = extract(this.product, "productData.productType", null) === "ExpressPass";
  }

  render() {
    const labels = {
      typeText: this.typeText,
      heading: this.headline,
      description: this.richTextDescripton,
    };

    const metadata = {
      location: this.location ? { label: this.location, icon: "icon-location" } : null,
      duration: this.duration ? { label: this.duration, icon: "icon-clock" } : null,
    };

    return (
      <section className="block block--max-width block--padded" data-contentful-id={this.props.contentful_id}>
        {this.isActivityBooking ? (
          <ActivityBooking labels={labels} metadata={metadata} product={this.props.product} />
        ) : (
          <BookableShowBooking {...this.props} />
        )}
      </section>
    );
  }
}

export const fragmentShowBookingBlock = graphql`
  fragment ShowBookingBlock on ContentfulShowBookingBlock {
    contentful_id
    id
    typeText
    headline
    introText {
      introText
    }
    todayText
    selectDateText
    pricePerBookingText
    extraInfoText
    noAvailaibleShowsText
    product {
      ...ProductBlock
    }
    pageLink {
      ...Link
    }
    remainingSlotsLimit
  }
`;
